import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Alert, Box, Chip, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import PageHeader from '../../components/common/PageHeader';
import api from '../../api/axiosInstance';

const formatDate = (value) => value ? new Date(value).toLocaleDateString('fr-FR') : '-';

export default function ClientDomains() {
  const { data: organizations = [] } = useSelector((state) => state.organizations.organizations);
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    api.get('/api/domain')
      .then(({ data }) => active && setDomains(Array.isArray(data) ? data : data.domains || []))
      .catch(() => active && setError('Erreur de chargement des noms de domaines.'))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, []);
  const organizationNames = useMemo(() => new Set(organizations.map((organization) => organization.name).filter(Boolean)), [organizations]);
  const rows = useMemo(() => domains.filter((domain) => {
    const organization = domain.organizationDetails?.name || domain.Organization?.name || domain.matchedOrganizationName || '';
    return !organizationNames.size || organizationNames.has(organization);
  }).sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''))), [domains, organizationNames]);

  return (
    <Box>
      <PageHeader section={organizations[0]?.name || 'Client'} title="Vos noms de domaines" sx={{ my: 1, mb: 3 }} />
      {error ? <Alert severity="error" sx={{ mb: 2 }}>Impossible de charger les noms de domaines.</Alert> : null}
      <Stack direction="row" spacing={1} sx={{ mb: 2 }}><Chip icon={<PublicIcon />} label={`${rows.length} domaine(s)`} /></Stack>
      <Paper variant="outlined">
        <TableContainer sx={{ maxHeight: 650 }}>
          <Table stickyHeader size="small">
            <TableHead><TableRow>
              <TableCell sx={{ fontWeight: 800 }}>Nom de domaine</TableCell>
              <TableCell sx={{ fontWeight: 800 }}>Expiration</TableCell>
              <TableCell sx={{ fontWeight: 800 }}>Certificat</TableCell>
              <TableCell sx={{ fontWeight: 800 }}>Source</TableCell>
            </TableRow></TableHead>
            <TableBody>
              {rows.map((domain) => <TableRow key={domain._id || domain.name} hover>
                <TableCell sx={{ fontWeight: 700 }}>{domain.name}</TableCell>
                <TableCell>{formatDate(domain.domainExpiration)}</TableCell>
                <TableCell>{formatDate(domain.certificateExpiration)}</TableCell>
                <TableCell><Chip size="small" variant="outlined" label={domain.source === 'ovh' ? 'OVH' : 'Hudu'} /></TableCell>
              </TableRow>)}
              {!loading && !rows.length ? <TableRow><TableCell colSpan={4} align="center" sx={{ py: 5, color: 'text.secondary' }}>Aucun nom de domaine trouvé.</TableCell></TableRow> : null}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
